<template>
  <v-container>
    <h1 class="page-title">{{ title }}</h1>
    <router-view />
  </v-container>
</template>

<script>
  export default {
    name: 'PageLayoutCore',
    data: () => ({
      title: ''
    }),
  }
</script>
